export interface MeetingLabelProps {
  text: string;
  className?: string;
}

export default function MeetingLabel({ text, className = '' }: MeetingLabelProps) {
  return (
    <span
      className={`font-robotoMedium font-semibold text-[14px] leading-[20px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark ${className}`}
    >
      {text}
    </span>
  );
}
